import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, Table, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import CustomFormCheck from "utils/CustomFormCheck";
import CustomTooltip from "utils/CustomTooltip";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import jsDig from "utils/jsDig";
import { RouterContext } from "../Onboarding";

export default function GoogleAdsAccess(props) {
  const route = useContext(RouterContext);
  const [idProvided, setIdProvided] = useState(false);

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  props.pageLocator();

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if (
      form.checkValidity() === true &&
      (jsDig(["Google Ads", "Full"], props.teamAccess) == "1" || jsDig(["Google Ads", "Restricted"], props.teamAccess) == "1")
    ) {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });

  const [accessGranted, setAccessGranted] = useState(
    jsDig(["Google Ads", "Full"], props.teamAccess) == "1" || jsDig(["Google Ads", "Restricted"], props.teamAccess) == "1"
  );

  const addDashes = (id) => {
    if (id.length < 12) {
      const cleanId = id ? id.split("-").join("") : id;
      let finalVal = id ? cleanId.match(/.{1,3}/g).join("-") : id;
      return finalVal;
    }
    return id;
  };

  const authenticateFunction = (platform) => {
    window.open(platform["auth_url"], '_blank');
  };

  const deauthorizeFunction = (platform) => {
    window.open(platform["deauth_url"], '_blank');
  };

  const resetMessage = (platformName) => {
    return (`Resetting ${capitalize(platformName)} token will require you to authenticate again`)
  }

  const authButton = (platform) => {
    if (platform.authenticated) {
      return (
        <>
          <Button className="mb-4 btn-lg text-center" variant="danger" onClick={() => deauthorizeFunction(platform)}>
            Reset Token
            <CustomTooltip faClass="text-white far fa-question-circle f18 pl-2" message={resetMessage(platform["title"])} inline={true} />
          </Button>
        </>
      )
    } else {
      return (
        <>
          <Button className="mb-4 btn-lg text-center" variant="success" onClick={() => authenticateFunction(platform)}>
            Authenticate
            <i className="fas fa-cog pl-2" style={{paddingRight: "0px", color: "unset", float: "unset"}}></i>
          </Button>
        </>
      )
    }
  }
  return (
    <>
      <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
      <Row className=" px-4 mb-3 pb-3 justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Grant Google Ads Access</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary ">
              On this page you will grant access to Google Ads. First, you can provide your account ID's below. This will be used in DataPulse and will
              additionally give {route.organization.name} the means to request access to your account. Once access is requested, the client can log into their Google Ads
              account and approve.
            </p>
          </div>
        </Col>
      </Row>
      <Row className="mb-5  justify-content-center">
        <Col className="mr-0" lg={6}>
          <Row >
            <Col md={12}>
              <p className="visby-bold pb-2 light-primary f14">Authenticate with Google:</p>
            </Col>
          </Row>
          <Row style={{ backgroundColor: "#E1E1E1", paddingTop: "20px" }}>
            <Col md={12} className="pr-0">
              <div>
                {authButton(props.api_platforms["google_ads"])}
                <p className="f-14 light-primary pb-3">{props.api_platforms["google_ads"]["authenticated"] ?
                  "You have already authenticated with Google Ads. If you need access to clients on a different account, reset your token and reauthenticate."
                  : "You must go through the authentication process before you can pull data from Google Ads!"
                  }
                </p>
              </div>
            </Col>
            <Col md={12} style={{marginBottom: "20px"}}>
              <p className="visby-bold pb-2 light-primary f14">Google Ads MCC ID (No '-'s):</p>
              <Form.Control
                required
                placeholder="Enter MCC ID"
                value={props.mccId ? props.mccId : ""}
                onChange={(e) => {props.setMccId(e.target.value); checkValidation()}}
                disabled={props.savedMccId.length > 4}
                name="google_ads_mcc_id"
                style={{maxWidth: "200px"}}
              />
              <p className="f-14 light-primary pt-3">{props.mccId && props.mccId != "" ?
                "MCC ID has already been set. If the value above is incorrect go to API Access to change it."
                : "MCC ID must be set to pull data from Google Ads."
                }
              </p>
            </Col>
          </Row>
          <Row>
            <Col className="mr-0" xs={12}>
              <p className="visby-bold mt-3 pb-2 light-primary f14">Provide your account information below:</p>
            </Col>
          </Row>
          <Row>
            <Col className="mr-0" xs={12}>
              <CustomFormCheck
                className="primary"
                id="ob-same-service"
                name="ob-same-service"
                label="Use different account IDs for all sub-services"
                checked={!props.sameId}
                onChange={() => props.setSameId(!props.sameId)}
              />
            </Col>
          </Row>
          <Row className="py-3 pl-0">
            {props.sameId ? (
              <div style={{ backgroundColor: "#E1E1E1", paddingBottom: "10px", width: "100%" }}>
                <Col className="pr-0">
                  <div className="table-responsive">
                    <Table className="overflow-hidden">
                      <thead>
                        <tr>
                          <td style={{ width: "145px" }} className="pl-3 f12 light-primary text-left">
                            ID
                          </td>
                          <td></td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <Form.Control
                              name={`google-ads-id-all}`}
                              size="sm"
                              placeholder="ID"
                              style={{ width: "145px" }}
                              value={jsDig([0, "id"], props.allGoogleAdsIds) ? jsDig([0, "id"], props.allGoogleAdsIds) : ""}
                              onChange={(e) => {
                                let newGoogleAdsIds = props.allGoogleAdsIds;
                                if (!newGoogleAdsIds[0]) {
                                  newGoogleAdsIds[0] = {};
                                }
                                newGoogleAdsIds[0]["id"] = addDashes(e.target.value);
                                props.setAllGoogleAdsIds([...newGoogleAdsIds]);
                              }}
                              id={`ob-google-ads-id`}
                              required
                              type="text"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </div>
            ) : (
              <>
                {["Search", "Display", "Video"].map((section, idx) => {
                  return (
                    <div
                      key={section}
                      className="mb-2"
                      style={{ backgroundColor: "#E1E1E1", paddingBottom: "20px", paddingLeft: "10px", width: "100%" }}>
                      <Col className="pr-0">
                        <Row>
                          <Col>
                            <p className="f16 pt-3 pl-2 visby-bold text-info">{section}</p>
                          </Col>
                        </Row>
                        <div className="table-responsive">
                          <Table className="overflow-hidden">
                            <thead>
                              <tr>
                                <td style={{ width: "145px" }} className="pl-2 f12 light-primary text-left">
                                  ID
                                </td>

                                <td></td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <Form.Control
                                    name={`google-ads-id-${section}`}
                                    size="sm"
                                    placeholder="ID"
                                    style={{ width: "145px" }}
                                    value={
                                      section === "Search"
                                        ? jsDig([0, "id"], props.searchGoogleAdsIds)
                                          ? jsDig([0, "id"], props.searchGoogleAdsIds)
                                          : ""
                                        : section === "Display"
                                        ? jsDig([0, "id"], props.displayGoogleAdsIds)
                                          ? jsDig([0, "id"], props.displayGoogleAdsIds)
                                          : ""
                                        : section === "Video"
                                        ? jsDig([0, "id"], props.videoGoogleAdsIds)
                                          ? jsDig([0, "id"], props.videoGoogleAdsIds)
                                          : ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      if (section === "Search") {
                                        let newGoogleAdsIds1 = props.searchGoogleAdsIds;
                                        if (!newGoogleAdsIds1[0]) {
                                          newGoogleAdsIds1[0] = {};
                                        }
                                        newGoogleAdsIds1[0]["id"] = addDashes(e.target.value);
                                        props.setSearchGoogleAdsIds([...newGoogleAdsIds1]);
                                      } else if (section === "Display") {
                                        let newGoogleAdsIds2 = props.displayGoogleAdsIds;
                                        if (!newGoogleAdsIds2[0]) {
                                          newGoogleAdsIds2[0] = {};
                                        }
                                        newGoogleAdsIds2[0]["id"] = addDashes(e.target.value);
                                        props.setDisplayGoogleAdsIds([...newGoogleAdsIds2]);
                                      } else if (section === "Video") {
                                        let newGoogleAdsIds3 = props.videoGoogleAdsIds;
                                        if (!newGoogleAdsIds3[0]) {
                                          newGoogleAdsIds3[0] = {};
                                        }
                                        newGoogleAdsIds3[0]["id"] = addDashes(e.target.value);
                                        props.setVideoGoogleAdsIds([...newGoogleAdsIds3]);
                                      }
                                    }}
                                    id={`ob-google-ads-id-${section}`}
                                    required
                                    type="text"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    </div>
                  );
                })}
              </>
            )}
          </Row>
          {/* <Row className="my-4">
            <Col className="">
              <p className="f14 pb-2 mt-0 visby-bold light-primary">Email to grant access to:</p>
              <p className="f16 primary">support@digitalposition.com</p>
            </Col>
          </Row> */}
          <Row style={{ backgroundColor: "#E1E1E1"}}>
            <Col className="pr-0">
              <div style={{ marginTop: "14px" }}>
                <p className="f14 primary">Complete as many of the below steps as possible, and check to confirm.</p>
              </div>
              <div className="grey-box text-left" style={{ backgroundColor: "#E1E1E1", marginTop: "14px" }}>
                <div className="pb-1">
                  <input hidden name="current_onboarding_page" defaultValue={window.location.href} readOnly />
                  <CustomFormCheck
                    required
                    className="primary"
                    ads
                    id="ob-google-ads-provided"
                    name="google-ads-provided"
                    label="Account ID provided above, waiting for request."
                    checked={idProvided}
                    onChange={(e) => {
                      setIdProvided(!idProvided);
                    }}
                    dynamic
                  />
                </div>
                <div className="pb-1">
                  <CustomFormCheck
                    required
                    className="primary"
                    id="ob-google-ads-requested"
                    name="google-ads-requested"
                    label={`Access has been requested by ${route.organization.name}.`}
                    checked={props.teamAccess["Google Ads"]["Requested"] == "1"}
                    dynamic
                    onChange={(e) => {
                      let accessChecked = props.teamAccess;
                      accessChecked["Google Ads"]["Requested"] = props.teamAccess["Google Ads"]["Requested"] == "1" ? "0" : "1";
                      props.setTeamAccess({ ...accessChecked });
                    }}
                  />
                </div>
                <div className="pb-1">
                  <CustomFormCheck
                    required
                    className="primary"
                    id="ob-google-ads-approved"
                    name="google-ads-approved"
                    label="Access has been approved by client."
                    dynamic
                    checked={accessGranted}
                    onChange={(e) => {
                      setAccessGranted(!accessGranted);
                      let accessChecked = props.teamAccess;
                      accessChecked["Google Ads"]["Restricted"] = 0;
                      accessChecked["Google Ads"]["Full"] = 0;
                      props.setTeamAccess({ ...accessChecked });
                    }}
                  />
                </div>
                <div>
                  <p className="pl-3 pb-1 f16 primary">Please indicate access granted.</p>
                </div>

                <div className="pb-1 pl-3">
                  <CustomFormCheck
                    id="ob-google-ads-admin"
                    name="google-ads-admin"
                    label="Full"
                    disabled={!accessGranted}
                    checked={props.teamAccess["Google Ads"]["Full"] == "1"}
                    onChange={(e) => {
                      let accessChecked = props.teamAccess;
                      accessChecked["Google Ads"]["Restricted"] = "0";
                      accessChecked["Google Ads"]["Full"] = props.teamAccess["Google Ads"]["Full"] == "1" ? "0" : "1";
                      props.setTeamAccess({ ...accessChecked });
                    }}
                  />
                </div>
                <div className="pb-1 pl-3">
                  <CustomFormCheck
                    id="ob-google-ads-standard"
                    name="google-ads-standard"
                    label="Restricted"
                    disabled={!accessGranted}
                    checked={props.teamAccess["Google Ads"]["Restricted"] == "1"}
                    onChange={(e) => {
                      let accessChecked = props.teamAccess;
                      accessChecked["Google Ads"]["Full"] = "0";
                      accessChecked["Google Ads"]["Restricted"] = props.teamAccess["Google Ads"]["Restricted"] == "1" ? "0" : "1";
                      props.setTeamAccess({ ...accessChecked });
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        {/* <Col lg={4} className="mt-3">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/_HoMRLW-QhY"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ maxWidth: "100%" }}></iframe>
        </Col> */}
      </Row>
      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
